import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import '@/utils/transform.js';
import Transform from '@/utils/transform.ts';
import AlloyTouch from 'alloytouch';

interface ISuspendedBall {
  tap?: any
}

import './style.less';

@Component
export default class SuspendedBall extends tsx.Component<ISuspendedBall> {
  
  @Prop() public tap?: any;
  
  mounted () {
    const box: any = this.$refs.suspendedBall;
    Transform(box);
    const touchObject = new AlloyTouch({
      touch: box,
      tap: this.$props.tap,
      pressMove: (evt: { touches: { clientX: any; clientY: any; radiusX: any; radiusY: any; }[]; deltaY: string | number; deltaX: string | number; }) => {
        const {clientWidth, clientHeight} = document.body;
        console.log(clientWidth,clientHeight)
        const {clientX, clientY, radiusX, radiusY} = evt.touches[0]
        console.log(clientX, clientY, radiusX, radiusY)
        if (clientX < 0 ) {
          box.translateX = 0
          box.translateY += evt.deltaY;
          return
        }
        if (clientX > clientWidth - radiusX * 2 ) {
          box.translateX = clientWidth
          box.translateY += evt.deltaY;
          return
        }
        if (clientY <  radiusX) {
          box.translateY = 0
          box.translateX += evt.deltaX;
          return
        }
        if (clientY > clientHeight - radiusY * 2) {
          box.translateX += evt.deltaX;
          box.translateY = clientHeight
          return
        }
        
        box.translateX += evt.deltaX;
        box.translateY += evt.deltaY;
      },
      touchEnd: (evt: { changedTouches: { clientX: any; radiusX: any; }[]; }) => {
        const {clientWidth, clientHeight} = document.body;
        const {clientX, radiusX  } = evt.changedTouches[0]
        if (clientX > (clientWidth - radiusX * 2) / 2) {
          box.translateX = clientWidth - 60
        } else {
          box.translateX = 0
        }
      }
    })
  }
  
  render() {
    return (
      <div ref='suspendedBall' class='suspendedBall-container'>
        <img src={require('@/assets/svg/suspended.svg')} alt=""/>
      </div>
    )
  }
  
}